// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as IncentiveRepoConfig from "./IncentiveRepoConfig.bs.js";

var dummyInfoResponse = {
            "result": { 
                "campaigns": [
                    {
                        "start_date": 1664821800,
                        "end_date": 1665081000,
                        "campaign_status": "COMPLETED",
                        "ladder_based": false,
                        "payout": {
                            "param_name": "COMPLETED_ORDER_COUNT",
                            "config": [
                                {
                                    "target": 3,
                                    "incentive_amount": 300
                                }
                            ],
                            "param_current_value": 6
                        },
                        "validators": [
                            {
                                "validator_name": "ABRTG",
                                "threshold": 2,
                                "value": 0,
                                "status": true
                            },
                            {
                                "validator_name": "MISSED_ORDER",
                                "threshold": 2,
                                "value": 0,
                                "status": true
                            },
                            {
                                "validator_name": "FRAUD_ORDER",
                                "threshold": 0,
                                "value": 0,
                                "status": true
                            }
                        ]
                    },
                    {
                        "start_date": 1664344768226,
                        "end_date":  1669344768230,
                        "campaign_status": "COMPLETED",
                        "ladder_based": true,
                        "payout": {
                            "param_name": "COMPLETED_ORDER_COUNT",
                            "config": [
                                {
                                    "target": 10,
                                    "incentive_amount": 100
                                },
                                {
                                    "target": 100,
                                    "incentive_amount": 200
                                },
                                {
                                    "target": 200,
                                    "incentive_amount": 300
                                },
                                {
                                    "target": 1000,
                                    "incentive_amount": 300
                                },
                            ],
                            "param_current_value": 90
                        },
                        "validators":[
                            {
                                "validator_name": "MISSED_ORDER",
                                "threshold":  1,
                                "value":  1,
                                "status": true
                            },
                            {
                                "validator_name": "ABRTG",
                                "threshold":  1,
                                "value":  1,
                                "status": true
                            },
                            {
                                "validator_name": "FRAUD_ORDER",
                                "threshold":  1,
                                "value":  1,
                                "status": true
                            },
                        ]
                    },
                    {
                        "start_date": 1664344768226,
                        "end_date":  1669344768230,
                        "campaign_status": "DISQUALIFIED",
                        "ladder_based": false,
                        "payout": {
                            "param_name": "COMPLETED_ORDER_COUNT",
                            "config": [
                                {
                                    "target": 30,
                                    "incentive_amount": 200
                                }
                            ],
                            "param_current_value": 28
                        },
                        "validators":[
                            {
                                "validator_name": "MISSED_ORDER",
                                "threshold":  1,
                                "value":  1,
                                "status": true
                            }
                        ]
                    },
                    {
                        "start_date": 1664344768226,
                        "end_date":  1669344768230,
                        "campaign_status": "IN_PROGRESS",
                        "ladder_based": true,
                        "payout": {
                            "param_name": "COMPLETED_ORDER_COUNT",
                            "config": [
                                {
                                    "target": 10,
                                    "incentive_amount": 100
                                },
                                {
                                    "target": 30,
                                    "incentive_amount": 200
                                }
                            ],
                            "param_current_value": 28
                        },
                        "validators":[
                            {
                                "validator_name": "ABRTG",
                                "threshold":  1,
                                "value":  1,
                                "status": true
                            }
                        ]
                    }
                                
                ]					
            } 
        };

function fetchCampaign(msisdn, _auth_token, _country) {
  Logger$Catalyst.trace("fetchCampaignApiCalled");
  Logger$Catalyst.debug({
        payload: msisdn
      });
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyInfoResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(IncentiveRepoConfig.IncentiveCampaignResponseConverter.execute, result);
                            });
                }), "");
}

var IncentiveRepo = {
  dummyInfoResponse: dummyInfoResponse,
  fetchCampaign: fetchCampaign
};

export {
  IncentiveRepo ,
  
}
/* NetworkUtils Not a pure module */
